import {BrandModel} from "./BrandModel";
import {ImageModel} from "./ImageModel";
import {StudioCommentsModel} from "./StudioCommentsModel";

export interface StudioModel {
	name: string;
	images: {
		STUDIO_COVER: ImageModel;
		original: ImageModel;
	}[];
	createdAt: string;
	updatedAt: string;
	description: string;
	id: string;
	brand: BrandModel;
	likes: any[];
	review: StudioCommentsModel[];
};
